import { defineStore } from 'pinia'
import { ref } from 'vue'

// https://pinia.vuejs.org/core-concepts/#Setup-Stores
export const useGlobalStore = defineStore('global', () => {
  const isSidebarMinimized = ref(false)

  function toggleSidebar() {
    isSidebarMinimized.value = !isSidebarMinimized.value
  }

  return {
    isSidebarMinimized,
    toggleSidebar,
  }
})
